import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Global } from "../../classes/global";
import { MerchantService } from "../../services/merchant/merchant.service";

@Component({
  selector: 'app-get-tiktok-api-category-id',
  templateUrl: './get-tiktok-api-category-id.component.html',
  styleUrls: ['./get-tiktok-api-category-id.component.scss']
})
export class GetTiktokApiCategoryIdComponent implements OnInit {
  markets: string[] = ["US", "UK"];

  @ViewChild('getTiktokCatIdModal', { static: false }) private getTiktokCatIdModal: NgbModalRef;

  searchModel: any={
    market: 'US',
    keyword: ''
  }
  result= [];
  constructor(private modalService: NgbModal,
    private global: Global,
    private merchantService: MerchantService) { }

  ngOnInit(): void {
  }

  openModal() {
    this.modalService.open(this.getTiktokCatIdModal, { windowClass: "lModal" });
  }

  searchTiktokCat() {
    this.global.pageLoading = true;
    this.merchantService.searchTiktokCat(this.searchModel.market, this.searchModel.keyword)
      .subscribe(
        data => {
          this.global.pageLoading = false;
          this.result = data;
        });
  }

}
